var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
			_vm.$style['grid-column'],
			_vm.col > 0 ? _vm.$style[`grid-column--col-${_vm.col}`] : '',
			_vm.xs > 0 ? _vm.$style[`grid-column--col-xs-${_vm.xs}`] : '',
			_vm.sm > 0 ? _vm.$style[`grid-column--col-sm-${_vm.sm}`] : '',
			_vm.md > 0 ? _vm.$style[`grid-column--col-md-${_vm.md}`] : '',
			_vm.lg > 0 ? _vm.$style[`grid-column--col-lg-${_vm.lg}`] : '',
			_vm.xl > 0 ? _vm.$style[`grid-column--col-xl-${_vm.xl}`] : ''
		].filter(Boolean)},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }